import { render, staticRenderFns } from "./BracketFinalMatch.vue?vue&type=template&id=09f944d5&"
import script from "./BracketFinalMatch.vue?vue&type=script&lang=js&"
export * from "./BracketFinalMatch.vue?vue&type=script&lang=js&"
import style0 from "./BracketFinalMatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports